import { Platform } from 'react-native';
import { useMediaQuery } from 'react-responsive';

export const useMobileView = (mobile, desktop) => {
  const isMobileView = useMediaQuery({ maxWidth: 639 }) || Platform.OS !== 'web';
  return [isMobileView, isMobileView ? mobile : desktop];
};
